// extracted by mini-css-extract-plugin
export default {"btnContainer":"ToggleBtn_btnContainer__vrDQ0","isActive":"ToggleBtn_isActive__9ePns"};